/**
 * CatalogController.java 对应的 model
 */

import Model from './model'
const model = new Model()

class Catalog {

    /**
     * 根目录
     * @param params 参数
     * @returns {*}
     */
    static getRoot(params) {
        return model.post('catalog/getRoot', params)
    }

    /**
     * 资源目录
     * @param params 参数
     * @returns {*}
     */
    static getDir(params) {
        return model.post('catalog/getDir', params)
    }

}
export default Catalog



// WEBPACK FOOTER //
// ./bootsets/models/catalog.js